import { useEffect, useRef } from 'react';
import { useChannelActionContext, useChannelStateContext } from 'stream-chat-react';
import { getSearchMessage } from '../searchMessageMap';

export const MessageJumper = () => {
  const { channel } = useChannelStateContext();
  const { jumpToMessage } = useChannelActionContext();
  const lastJumpedId = useRef<string>(undefined);

  const searchMessageId = getSearchMessage(channel)?.id;

  useEffect(() => {
    if (!searchMessageId) return;
    if (lastJumpedId.current === searchMessageId) return;

    lastJumpedId.current = searchMessageId;
    jumpToMessage(searchMessageId, undefined, 5000);
  }, [searchMessageId, jumpToMessage]);

  return null;
};
